import type { PumsemApplicability as PumsemApplicabilityModel } from '../model/pumsem.type';

interface PumsemApplicabilityProps {
  applicability: PumsemApplicabilityModel;
}

/**
 * 적용 조건 — 포함 / 별도 계상 / 적용 범위.
 *
 * [주] 각주에서 끌어올려 **본문 옆 고정 자리**에 둔다. 실무에서 품셈 적용이
 * 담당자마다 갈리는 원인은 수치가 아니라 이 포함·제외 범위이기 때문이다.
 * 원문([주])은 아래에 그대로 남는다 — 이 카드는 요약이지 대체가 아니다.
 */
export function PumsemApplicability({
  applicability,
}: PumsemApplicabilityProps) {
  const { includes, excludes, scope } = applicability;
  if (includes.length === 0 && excludes.length === 0 && !scope) return null;

  return (
    <div className="space-y-2.5">
      {includes.length > 0 && (
        <section className="rounded-xl border border-emerald-200 bg-emerald-50 px-3.5 py-3 dark:border-emerald-500/25 dark:bg-emerald-500/10">
          <h3 className="mb-1.5 text-[13.5px] font-bold text-emerald-800 dark:text-emerald-300">
            이 품에 포함
          </h3>
          <ul className="space-y-1 text-[14px] leading-6 text-emerald-900 dark:text-emerald-100">
            {includes.map((entry) => (
              <li key={entry}>{entry}</li>
            ))}
          </ul>
        </section>
      )}

      {excludes.length > 0 && (
        <section className="rounded-xl border border-red-200 bg-red-50 px-3.5 py-3 dark:border-red-500/25 dark:bg-red-500/10">
          <h3 className="mb-1.5 text-[13.5px] font-bold text-red-800 dark:text-red-300">
            별도 계상
          </h3>
          <ul className="space-y-1 text-[14px] leading-6 text-red-900 dark:text-red-100">
            {excludes.map((entry) => (
              <li key={entry}>{entry}</li>
            ))}
          </ul>
        </section>
      )}

      {scope && (
        <section className="rounded-xl border border-neutral-200 px-3.5 py-3 dark:border-white/12">
          <h3 className="mb-1.5 text-[13.5px] font-bold text-neutral-600 dark:text-neutral-300">
            적용 범위
          </h3>
          <p className="text-[14px] leading-6 text-neutral-700 dark:text-neutral-300">
            {scope}
          </p>
        </section>
      )}
    </div>
  );
}
